import { create } from 'zustand';

interface RemoveModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const useRemoveModal = create<RemoveModalStore>(set => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}));

export default useRemoveModal;
